import { render } from "./AposDocContextMenu.vue?vue&type=template&id=697fd80f"
import script from "./AposDocContextMenu.vue?vue&type=script&lang=js"
export * from "./AposDocContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"doc-type/ui/apos/components/AposDocContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "697fd80f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('697fd80f', __exports__)) {
    api.reload('697fd80f', __exports__)
  }
  
  module.hot.accept("./AposDocContextMenu.vue?vue&type=template&id=697fd80f", () => {
    api.rerender('697fd80f', render)
  })

}


export default __exports__